import { ReducerMap, createTypedContext } from '@aptus-financial/react-common-lib';

import { publicClientApplication } from '@af-fp/oauth/microsoft';
import { ApiResult } from '@af-fp/types';

import { AuthenticationContextActions } from './actions';

export type AuthenticationState = ApiResult<{
  roles: string[] | null;
  email?: string | null;
  name?: string | null;
  featureToggles?: Partial<Record<string, boolean>>;
}>;

const actionHandlerFactory = (): ReducerMap<AuthenticationContextActions, AuthenticationState> => {
  const self: ReducerMap<AuthenticationContextActions, AuthenticationState> = {
    login: (_, action) => {
      localStorage.setItem('auth', 'true');
      return { loaded: true, ...action };
    },
    logout: () => {
      localStorage.removeItem('auth');
      publicClientApplication.clearCache();

      return { loaded: true, roles: null };
    },
  };

  return self;
};

export const {
  hook: useAuthenticationContext,
  dispatchHook: useAuthenticationDispatch,
  container: AuthenticationContextContainer,
} = createTypedContext(
  'Authentication',
  {
    roles: null,
  },
  actionHandlerFactory(),
);
